module.exports = __webpack_public_path__ + "static/media/checkout_image.6948b6bb.svg";